module.exports = __webpack_public_path__ + "static/media/hot_wxgyj.6631f5ed.png";